module.exports = __webpack_public_path__ + "static/media/mcf-7PacliSearch.3aecbf61.png";